module.exports = __webpack_public_path__ + "img/dev.9aa64df1.png";